var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-4"},[_c('SideBar')],1),_c('div',{staticClass:"col-12 col-md-8",attrs:{"id":"view"}},[_c('router-view')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }